import type { FC } from 'react';
import { videos, type VideoItem } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

interface VideoGridProps {
  category: string;
}

const VideoGrid: FC<VideoGridProps> = ({ category }) => {
  const filteredVideos: VideoItem[] = category === 'all'
    ? videos
    : videos.filter(v => v.category === category);

  if (filteredVideos.length === 0) {
    return (
      <section className="py-12">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
          <div className="py-16">
            <i className="ri-video-line text-5xl text-foreground-600"></i>
            <p className="text-foreground-500 mt-4">该分类暂无内容，敬请期待</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-8">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {filteredVideos.map((video, index) => (
            <div
              key={video.id}
              className="animate-fade-in-up"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <VideoCard video={video} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoGrid;